const validatePriorityCode = (value: any) => {

    if (
        value &&
        value.length > 0
    ) {
        return true;
    } else {
        return false;
    }
}


/**
 * Does this API error represent a rejected priority code?
 *
 * The caller needs to separate "your code is wrong" (show the user an error,
 * stop resending the code) from "the API is having a moment" (retain state,
 * retry on the next poll). Matching the exact string "Invalid priority code"
 * made that distinction brittle: any rewording server-side silently
 * downgraded a rejection into a generic error and the user got no feedback.
 *
 * Kept deliberately narrow — it must not swallow throttle/5xx messages.
 */
const isInvalidPriorityCodeError = (message: unknown): boolean => {
    if (typeof message !== 'string') return false;
    const normalised = message.trim().toLowerCase();
    if (!normalised.includes('priority code')) return false;
    return normalised.includes('invalid')
        || normalised.includes('not valid')
        || normalised.includes('expired')
        || normalised.includes('not found');
}


export { validatePriorityCode, isInvalidPriorityCodeError }
